/**
 * The pure drop-math behind the Build Order section's manual drag
 * (005-build-project Phase 6).
 *
 * Given the current flat id order the section shows and a drag's `active`/`over`
 * ids, it computes the new id sequence the drop produces — a single
 * `arrayMove` over ONE sortable sequence (both "Ready to start" and "Waiting on"
 * rows live in it, so a blocked row can be dragged above its blocker; the move is
 * always allowed here — the contradiction is shown elsewhere, never prevented).
 *
 * Returns `null` when the drop is a no-op (dropped on itself, off any row, or an
 * id not in the order) so the caller can skip the optimistic set + the write.
 *
 * Pure (no React, no IO): unit-testable in isolation. The component feeds the
 * result straight to phase 5's ungated `reorder(sequence)`.
 */

import { arrayMove } from '@dnd-kit/sortable';

export function buildOrderDragReorder(
  orderIds: ReadonlyArray<string>,
  activeId: string,
  overId: string | null | undefined
): string[] | null {
  if (!overId || activeId === overId) return null;
  const from = orderIds.indexOf(activeId);
  const to = orderIds.indexOf(overId);
  if (from < 0 || to < 0) return null;
  return arrayMove([...orderIds], from, to);
}
